import { createApiClient, env } from '@botto/core';
import type { paths } from './generated/schema';

/**
 * CDP API client (bott-cdp).
 *
 * Regenerate types: `pnpm --filter @botto/module-cdp generate:api`
 */
/** CDP uses the `cdp` audience access JWT as `Authorization: Bearer`. */
export const cdpClient = createApiClient<paths>({
  baseUrl: env.cdpApiUrl,
  audience: 'cdp',
});
